/* eslint-disable jsx-a11y/anchor-is-valid */

import {FC} from 'react'
import {useAuth} from '../../../modules/auth'
import {Cal} from '../components/Calendar'
import {PageTitle} from '../../../../_metronic/layout/core'

const DashboardPage: FC = () => {
  const {currentUser} = useAuth()

  return (
    <>
      <Cal />
      {/* begin::Row */}
      <div className='flex flex-col lg:flex-row justify-between w-full gap-4 my-3'>
        <div className='w-full'>
          {currentUser && currentUser?.role_id <= 3 && (
            <div className='flex flex-col lg:flex-row gap-8 lg:gap-4 mb-3 w-full'>
              {/* content goes here */}
            </div>
          )}
        </div>
      </div>
      {/* end::Row */}
    </>
  )
}

const DashboardWrapper: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>Dashboard</PageTitle>
      <DashboardPage />
    </>
  )
}

export default DashboardWrapper
